import React from "react";
import ReactFileReader from "react-file-reader";
import cogoToast from "cogo-toast";
import axios from 'axios';
import { LOCAL_STORAGE } from "../../../config/const";
import { isFileValid } from "../../../utils/validation";

const PostFilesAxios = async function (props = {}) {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId;
    let customerNo = LOCAL_STORAGE.customerNo;
  
    let formData = new FormData();
    formData.append("customerNo", customerNo);
    formData.append("customerNumber", customerNo);
    formData.append("userId", userId);
    formData.append("document", props.createItems.documentContent);
  
    var config = {
      method: 'put',
      url: `${process.env.REACT_APP_BASE_URL}${props.url}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
        Authorization: `${token}`,
      },
      data: formData
    };
    console.log({config})
  
    try {
      return new Promise((resolve, reject) => {
        axios(config)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  };

const UploadFile = ({ field: { name }, form: { setFieldValue }, ...props }) => {

    const handleFiles = (files) => {
        let file = files.fileList[0];
        const validTypes = ["jpeg", "png", "pdf"];
        const maxFileSize = 5000000
        
        const fileValidationResult = isFileValid(file, validTypes, maxFileSize);

        if (fileValidationResult.error) {
            cogoToast.error(fileValidationResult.message, { position: 'top-right' });
            return;
        }

        let data = {
            documentContent: file,
            documentName: name,
            orderNo: props.values.orderNo ? props.values.orderNo : "",
            deliveryNo: props.values.deliveryNo ? props.values.deliveryNo : "",
        };
        PostFilesAxios({
            url: `/masters/transporterMaster/addDocument`,
            createItems: data,
        })
            .then((res) => {
                setFieldValue(name, res.data.message.key);
            })
            .catch((err) => { console.log(err); cogoToast.error(err); })
    };

    return (
        <>
            <ReactFileReader
                base64={true}
                fileTypes={props.typer}
                handleFiles={handleFiles}
                {...props}
            >
                <button type="button" className={props.className}>
                    <i className="fas fa-upload"></i> {props.buttonName}
                </button>
            </ReactFileReader>
        </>
    );
};

export default UploadFile;
